import { IPublicClientApplication } from "@azure/msal-browser";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

import theme from './theme';
import { loginRequest } from './config/authConfig';
import Button from "@mui/material/Button";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { Provider as ReduxProvider } from 'react-redux';

import './index.css';

import store from "./reducers/store";
import { NavigationView } from "./components/navigation";
import { Grid, Grid2 } from "@mui/material";
import { isProd } from "./env/environment";

/**
 * AuthenticatedTemplate and UnauthenticatedTemplate components will 
 * only render their children if a user is authenticated or unauthenticated
 */
const AppView = () => {
    // useMsal is hook that returns the PublicClientApplication instance
    const { instance } = useMsal();

    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };
    
    return (
        <>
            <AuthenticatedTemplate>
                <NavigationView/>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <div className="entryroot">
                    <div className="entry">
                        <Grid container lg={12} direction="column" spacing={2} alignItems="center" justifyContent="center" textAlign="center">
                            <img src='/logo800.png' className="logo" alt="logo" />
                            <h2 color="primary">
                                {isProd() ? "Pacy Admin" : "Pacy Admin Dev"}
                            </h2>
                            <Button 
                                variant="outlined" 
                                color="primary" 
                                size="large"
                                className="signin"
                                onClick={handleLoginRedirect}>
                                Sign in
                            </Button>
                        </Grid>
                    </div>
                </div>
            </UnauthenticatedTemplate>
        </>
    );
};


type AppProps = {
    pca: IPublicClientApplication
};


/**
 * msal-react is built on the React context API and all parts of your app that require authentication must be 
 * wrapped in the MsalProvider component
 */
const App = ({ pca }: AppProps) => {
    return (
        <ThemeProvider theme={theme}>
            <ReduxProvider store={store}>
                    <MsalProvider instance={pca}>
                        <AppView/>
                    </MsalProvider>
            </ReduxProvider>
        </ThemeProvider>
    );
};

export default App;
